import React from 'react';
import { recordCarouselControlClickEvent } from './carouselControlClickEvents';
import * as styles from './CarouselSliderButton.module.scss';
import Button from '../../components/Button';
import SVGIcon from '../../components/SVGIcon';
import nextIcon from '../../icons/carousel-slider-button-next.svg';
import previousIcon from '../../icons/carousel-slider-button-previous.svg';

interface CarouselSliderButtonProps {
  direction: 'previous' | 'next';
  imageCount: number;
  selectedIndex: number;
  onSelectedIndexChange: (index: number) => void;
}

const CarouselSliderButton = ({
  direction,
  imageCount,
  selectedIndex,
  onSelectedIndexChange,
}: CarouselSliderButtonProps) => (
  <Button
    aria-label={`${direction === 'next' ? 'Next' : 'Previous'} Slide`}
    className={styles.button}
    onClick={({ nativeEvent }) => {
      recordCarouselControlClickEvent(nativeEvent);

      if (direction === 'next') {
        onSelectedIndexChange((selectedIndex + 1) % imageCount);
      } else {
        onSelectedIndexChange((selectedIndex - 1 + imageCount) % imageCount);
      }
    }}
  >
    <SVGIcon className={styles.img} size={48}>
      {direction === 'next' ? nextIcon : previousIcon}
    </SVGIcon>
  </Button>
);

export default CarouselSliderButton;
